import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './Present.css';

function TFrangos() {
    const [frangos, setFrangos] = useState([]);
    const [divisiones, setDivisiones] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [formulario, setFormulario] = useState({
        idDivision: '',
        idSucursal: '',
        boca: '1',
        tipoDoc: '',
        timbrado: '',
        desde: '',
        hasta: '',
        ultValor: '',
        obs: '',
        vencTimbrado: '',
        iniTimbrado: ''
    });
    const [modoEdicion, setModoEdicion] = useState(false);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [errores, setErrores] = useState({});
    const [busqueda, setBusqueda] = useState('');

    // Estados para el dropdown de sucursal con búsqueda
    const [dropdownSucursalAbierto, setDropdownSucursalAbierto] = useState(false);
    const [busquedaSucursal, setBusquedaSucursal] = useState('');
    const dropdownSucursalRef = useRef(null);

    const TIPOS_DOC = ['FCO', 'NCR', 'DEB', 'REM'];

    useEffect(() => {
        cargarFrangos();
        cargarDivisiones();
        cargarSucursales();
    }, []);

    // Cerrar dropdown al hacer clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownSucursalRef.current && !dropdownSucursalRef.current.contains(event.target)) {
                setDropdownSucursalAbierto(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const cargarFrangos = async () => {
        try {
            const response = await axios.get('/api/frangos');
            setFrangos(response.data);
        } catch (error) {
            console.error('Error al cargar rangos:', error);
            alert('Error al cargar los rangos');
        }
    };

    const cargarDivisiones = async () => {
        try {
            const response = await axios.get('/api/divisiones');
            setDivisiones(response.data);
        } catch (error) {
            console.error('Error al cargar divisiones:', error);
        }
    };

    const cargarSucursales = async () => {
        try {
            const response = await axios.get('/api/sucursales');
            setSucursales(response.data);
        } catch (error) {
            console.error('Error al cargar sucursales:', error);
        }
    };

    // Función para convertir fecha YYYY-MM-DD a DD/MM/YYYY
    const formatearFechaDisplay = (fecha) => {
        if (!fecha) return '';
        const [year, month, day] = fecha.split('-');
        return `${day}/${month}/${year}`;
    };

    // Función para convertir fecha DD/MM/YYYY a YYYY-MM-DD
    const formatearFechaInput = (fecha) => {
        if (!fecha) return '';
        if (fecha.includes('-')) return fecha; // Ya está en formato correcto
        const [day, month, year] = fecha.split('/');
        return `${year}-${month}-${day}`;
    };

    const validarFormulario = () => {
        const nuevosErrores = {};

        if (!formulario.idDivision) {
            nuevosErrores.idDivision = 'Debe seleccionar una división';
        }

        if (!formulario.idSucursal) {
            nuevosErrores.idSucursal = 'Debe seleccionar una sucursal';
        }

        if (!formulario.boca) {
            nuevosErrores.boca = 'La boca es requerida';
        }

        if (!formulario.tipoDoc) {
            nuevosErrores.tipoDoc = 'Debe seleccionar un tipo de documento';
        }

        if (!formulario.timbrado.trim()) {
            nuevosErrores.timbrado = 'El timbrado es requerido';
        } else if (formulario.timbrado.trim().length > 25) {
            nuevosErrores.timbrado = 'El timbrado no puede tener más de 25 caracteres';
        }

        if (!formulario.desde) {
            nuevosErrores.desde = 'El número desde es requerido';
        }

        if (!formulario.hasta) {
            nuevosErrores.hasta = 'El número hasta es requerido';
        } else if (parseInt(formulario.hasta) < parseInt(formulario.desde)) {
            nuevosErrores.hasta = 'El número hasta debe ser mayor o igual al número desde';
        }

        if (!formulario.ultValor) {
            nuevosErrores.ultValor = 'El último valor es requerido';
        }

        if (!formulario.iniTimbrado) {
            nuevosErrores.iniTimbrado = 'La fecha de inicio de timbrado es requerida';
        }

        if (!formulario.vencTimbrado) {
            nuevosErrores.vencTimbrado = 'La fecha de vencimiento es requerida';
        } else if (formulario.iniTimbrado && formulario.vencTimbrado < formulario.iniTimbrado) {
            nuevosErrores.vencTimbrado = 'La fecha de vencimiento debe ser posterior a la fecha de inicio';
        }

        setErrores(nuevosErrores);
        return Object.keys(nuevosErrores).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormulario(prev => ({
            ...prev,
            [name]: value
        }));

        if (errores[name]) {
            setErrores(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validarFormulario()) {
            return;
        }

        try {
            const datosEnviar = {
                idDivision: formulario.idDivision,
                idSucursal: parseInt(formulario.idSucursal),
                boca: parseInt(formulario.boca),
                tipoDoc: formulario.tipoDoc,
                timbrado: formulario.timbrado.trim(),
                desde: parseInt(formulario.desde),
                hasta: parseInt(formulario.hasta),
                ultValor: parseInt(formulario.ultValor),
                obs: formulario.obs.trim() || ' ',
                vencTimbrado: formulario.vencTimbrado,
                iniTimbrado: formulario.iniTimbrado
            };

            if (modoEdicion) {
                const url = `/api/frangos/${formulario.idDivision}/${formulario.idSucursal}/${formulario.boca}/${formulario.tipoDoc}/${encodeURIComponent(formulario.timbrado)}`;
                await axios.put(url, datosEnviar);
                alert('Rango actualizado exitosamente');
            } else {
                await axios.post('/api/frangos', datosEnviar);
                alert('Rango creado exitosamente');
            }

            cerrarModal();
            cargarFrangos();
        } catch (error) {
            console.error('Error al guardar rango:', error);
            alert('Error al guardar el rango: ' + (error.response?.data?.mensaje || error.message));
        }
    };

    const handleEditar = (frango) => {
        setFormulario({
            idDivision: frango.idDivision,
            idSucursal: frango.idSucursal?.toString() || '',
            boca: frango.boca?.toString() || '1',
            tipoDoc: frango.tipoDoc,
            timbrado: frango.timbrado,
            desde: frango.desde?.toString() || '',
            hasta: frango.hasta?.toString() || '',
            ultValor: frango.ultValor?.toString() || '',
            obs: frango.obs || '',
            vencTimbrado: frango.vencTimbrado || '',
            iniTimbrado: frango.iniTimbrado || ''
        });
        setModoEdicion(true);
        setMostrarModal(true);
        setErrores({});
    };

    const handleEliminar = async (frango) => {
        if (window.confirm(`¿Está seguro de eliminar este rango?`)) {
            try {
                const url = `/api/frangos/${frango.idDivision}/${frango.idSucursal}/${frango.boca}/${frango.tipoDoc}/${encodeURIComponent(frango.timbrado)}`;
                await axios.delete(url);
                alert('Rango eliminado exitosamente');
                cargarFrangos();
            } catch (error) {
                console.error('Error al eliminar rango:', error);
                alert('Error al eliminar el rango');
            }
        }
    };

    const abrirModalNuevo = () => {
        const ahora = new Date();
        const hoy = `${ahora.getFullYear()}-${String(ahora.getMonth() + 1).padStart(2, '0')}-${String(ahora.getDate()).padStart(2, '0')}`;
        setFormulario({
            idDivision: '',
            idSucursal: '',
            boca: '1',
            tipoDoc: '',
            timbrado: '',
            desde: '',
            hasta: '',
            ultValor: '',
            obs: '',
            vencTimbrado: '',
            iniTimbrado: hoy
        });
        setModoEdicion(false);
        setMostrarModal(true);
        setErrores({});
    };

    const cerrarModal = () => {
        setMostrarModal(false);
        const ahora = new Date();
        const hoy = `${ahora.getFullYear()}-${String(ahora.getMonth() + 1).padStart(2, '0')}-${String(ahora.getDate()).padStart(2, '0')}`;
        setFormulario({
            idDivision: '',
            idSucursal: '',
            boca: '1',
            tipoDoc: '',
            timbrado: '',
            desde: '',
            hasta: '',
            ultValor: '',
            obs: '',
            vencTimbrado: '',
            iniTimbrado: hoy
        });
        setModoEdicion(false);
        setErrores({});
    };

    // Funciones auxiliares (deben estar antes de usarse)
    const obtenerNombreDivision = (idDivision) => {
        const division = divisiones.find(d => d.idDivision === idDivision);
        return division ? division.nomDivision : idDivision;
    };

    const obtenerNombreSucursal = (idSucursal) => {
        const sucursal = sucursales.find(s => s.idSucursal === idSucursal);
        return sucursal ? sucursal.nombre : idSucursal;
    };

    // Funciones para el selector de sucursal
    const filtrarSucursales = (busqueda) => {
        if (!busqueda) return sucursales;
        const busquedaLower = busqueda.toLowerCase();
        return sucursales.filter(sucursal =>
            sucursal.idSucursal?.toString().includes(busquedaLower) ||
            sucursal.nombre?.toLowerCase().includes(busquedaLower)
        );
    };

    const seleccionarSucursal = (sucursal) => {
        setFormulario(prev => ({ ...prev, idSucursal: sucursal.idSucursal.toString() }));
        setDropdownSucursalAbierto(false);
        setBusquedaSucursal('');
        if (errores.idSucursal) {
            setErrores(prev => ({ ...prev, idSucursal: '' }));
        }
    };

    const limpiarSucursal = () => {
        setFormulario(prev => ({ ...prev, idSucursal: '' }));
        setBusquedaSucursal('');
    };

    const obtenerDescripcionSucursal = (idSucursal) => {
        const sucursal = sucursales.find(s => s.idSucursal === parseInt(idSucursal));
        return sucursal ? sucursal.nombre : '';
    };

    const exportarExcel = () => {
        const datosExportar = frangosFiltrados.map(frango => ({
            'División': obtenerNombreDivision(frango.idDivision),
            'Sucursal': obtenerNombreSucursal(frango.idSucursal),
            'Boca': frango.boca,
            'Tipo Doc': frango.tipoDoc,
            'Timbrado': frango.timbrado,
            'Desde': frango.desde,
            'Hasta': frango.hasta,
            'Último Valor': frango.ultValor,
            'Inicio Timbrado': formatearFechaDisplay(frango.iniTimbrado),
            'Venc. Timbrado': formatearFechaDisplay(frango.vencTimbrado),
            'Observaciones': frango.obs
        }));

        const ws = XLSX.utils.json_to_sheet(datosExportar);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Rangos');
        XLSX.writeFile(wb, 'rangos_facturacion.xlsx');
    };

    const frangosFiltrados = frangos.filter(frango =>
        frango.timbrado.toLowerCase().includes(busqueda.toLowerCase()) ||
        frango.tipoDoc.toLowerCase().includes(busqueda.toLowerCase()) ||
        obtenerNombreDivision(frango.idDivision).toLowerCase().includes(busqueda.toLowerCase()) ||
        obtenerNombreSucursal(frango.idSucursal).toLowerCase().includes(busqueda.toLowerCase())
    );

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Rangos de Facturación</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo Rango
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>División</th>
                            <th>Sucursal</th>
                            <th>Boca</th>
                            <th>Tipo Doc</th>
                            <th>Timbrado</th>
                            <th>Desde</th>
                            <th>Hasta</th>
                            <th>Último</th>
                            <th>Inicio</th>
                            <th>Vencimiento</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {frangosFiltrados.length > 0 ? (
                            frangosFiltrados.map((frango, index) => (
                                <tr key={index}>
                                    <td>{obtenerNombreDivision(frango.idDivision)}</td>
                                    <td>{obtenerNombreSucursal(frango.idSucursal)}</td>
                                    <td>{frango.boca}</td>
                                    <td>{frango.tipoDoc}</td>
                                    <td>{frango.timbrado}</td>
                                    <td style={{ textAlign: 'right' }}>{frango.desde}</td>
                                    <td style={{ textAlign: 'right' }}>{frango.hasta}</td>
                                    <td style={{ textAlign: 'right' }}>{frango.ultValor}</td>
                                    <td>{formatearFechaDisplay(frango.iniTimbrado)}</td>
                                    <td>{formatearFechaDisplay(frango.vencTimbrado)}</td>
                                    <td>
                                        <button
                                            className="btn-accion"
                                            onClick={() => handleEditar(frango)}
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            className="btn-accion"
                                            onClick={() => handleEliminar(frango)}
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="11" className="sin-datos">
                                    No se encontraron rangos
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="footer-tabla">
                Total de rangos: {frangosFiltrados.length}
            </div>

            {mostrarModal && (
                <div className="modal-overlay">
                    <div className="modal-contenido" style={{ maxWidth: '700px' }}>
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Rango' : 'Nuevo Rango'}</h3>
                            <button className="btn-cerrar" onClick={cerrarModal}>×</button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                {/* División */}
                                <div className="form-group">
                                    <label>División *</label>
                                    <select
                                        name="idDivision"
                                        className={`form-input ${errores.idDivision ? 'form-input-error' : ''}`}
                                        value={formulario.idDivision}
                                        onChange={handleChange}
                                        disabled={modoEdicion}
                                    >
                                        <option value="">Seleccione...</option>
                                        {divisiones.map(div => (
                                            <option key={div.idDivision} value={div.idDivision}>
                                                {div.nomDivision}
                                            </option>
                                        ))}
                                    </select>
                                    {errores.idDivision && <span className="form-error">{errores.idDivision}</span>}
                                </div>

                                {/* Sucursal */}
                                <div className="form-group">
                                    <label>Sucursal *</label>
                                    <div className="cuenta-selector" ref={dropdownSucursalRef}>
                                        <input
                                            type="text"
                                            value={formulario.idSucursal ? '' : busquedaSucursal}
                                            onChange={(e) => {
                                                setBusquedaSucursal(e.target.value);
                                                setDropdownSucursalAbierto(true);
                                            }}
                                            onFocus={() => !modoEdicion && setDropdownSucursalAbierto(true)}
                                            placeholder="Buscar sucursal..."
                                            className={`form-input ${errores.idSucursal ? 'form-input-error' : ''}`}
                                            disabled={modoEdicion}
                                        />
                                        {formulario.idSucursal && (
                                            <div className="cuenta-seleccionada">
                                                <span className="cuenta-numero">{formulario.idSucursal}</span>
                                                <span className="cuenta-descripcion">({obtenerDescripcionSucursal(formulario.idSucursal)})</span>
                                                {!modoEdicion && (
                                                    <button
                                                        type="button"
                                                        onClick={limpiarSucursal}
                                                        className="btn-clear-cuenta"
                                                    >
                                                        ✖
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                        {dropdownSucursalAbierto && !modoEdicion && (
                                            <div className="cuenta-dropdown">
                                                {filtrarSucursales(busquedaSucursal).length === 0 ? (
                                                    <div className="cuenta-item-vacio">No se encontraron sucursales</div>
                                                ) : (
                                                    filtrarSucursales(busquedaSucursal).slice(0, 50).map(sucursal => (
                                                        <div
                                                            key={sucursal.idSucursal}
                                                            onClick={() => seleccionarSucursal(sucursal)}
                                                            className="cuenta-item"
                                                        >
                                                            <span className="cuenta-descripcion">{sucursal.nombre}</span>
                                                            <span className="cuenta-numero">({sucursal.idSucursal})</span>
                                                        </div>
                                                    ))
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    {errores.idSucursal && <span className="form-error">{errores.idSucursal}</span>}
                                </div>

                                {/* Boca */}
                                <div className="form-group">
                                    <label>Boca *</label>
                                    <input
                                        type="number"
                                        name="boca"
                                        className={`form-input ${errores.boca ? 'form-input-error' : ''}`}
                                        value={formulario.boca}
                                        onChange={handleChange}
                                        disabled={modoEdicion}
                                    />
                                    {errores.boca && <span className="form-error">{errores.boca}</span>}
                                </div>

                                {/* Tipo Doc */}
                                <div className="form-group">
                                    <label>Tipo Documento *</label>
                                    <select
                                        name="tipoDoc"
                                        className={`form-input ${errores.tipoDoc ? 'form-input-error' : ''}`}
                                        value={formulario.tipoDoc}
                                        onChange={handleChange}
                                        disabled={modoEdicion}
                                    >
                                        <option value="">Seleccione...</option>
                                        {TIPOS_DOC.map(tipo => (
                                            <option key={tipo} value={tipo}>{tipo}</option>
                                        ))}
                                    </select>
                                    {errores.tipoDoc && <span className="form-error">{errores.tipoDoc}</span>}
                                </div>

                                {/* Timbrado */}
                                <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                                    <label>Timbrado *</label>
                                    <input
                                        type="text"
                                        name="timbrado"
                                        className={`form-input ${errores.timbrado ? 'form-input-error' : ''}`}
                                        value={formulario.timbrado}
                                        onChange={handleChange}
                                        maxLength="25"
                                        disabled={modoEdicion}
                                    />
                                    {errores.timbrado && <span className="form-error">{errores.timbrado}</span>}
                                </div>

                                {/* Desde */}
                                <div className="form-group">
                                    <label>Número Desde *</label>
                                    <input
                                        type="number"
                                        name="desde"
                                        className={`form-input ${errores.desde ? 'form-input-error' : ''}`}
                                        value={formulario.desde}
                                        onChange={handleChange}
                                    />
                                    {errores.desde && <span className="form-error">{errores.desde}</span>}
                                </div>

                                {/* Hasta */}
                                <div className="form-group">
                                    <label>Número Hasta *</label>
                                    <input
                                        type="number"
                                        name="hasta"
                                        className={`form-input ${errores.hasta ? 'form-input-error' : ''}`}
                                        value={formulario.hasta}
                                        onChange={handleChange}
                                    />
                                    {errores.hasta && <span className="form-error">{errores.hasta}</span>}
                                </div>

                                {/* Último Valor */}
                                <div className="form-group">
                                    <label>Último Valor *</label>
                                    <input
                                        type="number"
                                        name="ultValor"
                                        className={`form-input ${errores.ultValor ? 'form-input-error' : ''}`}
                                        value={formulario.ultValor}
                                        onChange={handleChange}
                                    />
                                    {errores.ultValor && <span className="form-error">{errores.ultValor}</span>}
                                </div>

                                {/* Fecha Inicio Timbrado */}
                                <div className="form-group">
                                    <label>Inicio Timbrado *</label>
                                    <input
                                        type="date"
                                        name="iniTimbrado"
                                        className={`form-input ${errores.iniTimbrado ? 'form-input-error' : ''}`}
                                        value={formulario.iniTimbrado}
                                        onChange={handleChange}
                                    />
                                    {errores.iniTimbrado && <span className="form-error">{errores.iniTimbrado}</span>}
                                </div>

                                {/* Fecha Vencimiento */}
                                <div className="form-group">
                                    <label>Vencimiento Timbrado *</label>
                                    <input
                                        type="date"
                                        name="vencTimbrado"
                                        className={`form-input ${errores.vencTimbrado ? 'form-input-error' : ''}`}
                                        value={formulario.vencTimbrado}
                                        onChange={handleChange}
                                    />
                                    {errores.vencTimbrado && <span className="form-error">{errores.vencTimbrado}</span>}
                                </div>

                                {/* Observaciones */}
                                <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                                    <label>Observaciones</label>
                                    <textarea
                                        name="obs"
                                        className="form-input"
                                        value={formulario.obs}
                                        onChange={handleChange}
                                        rows="3"
                                        maxLength="150"
                                    />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-cancelar" onClick={cerrarModal}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TFrangos;
